export default __webpack_public_path__ + "static/media/Ballroll_00257.f0575c6e.png";